<template>
  <v-list-item complex hover :isDisabledWithDropdown="isDisabled" @click.native="downloadFile()">
    <v-list-cell class="relative thumbnail" style="flex: none !important" v-if="!isReady">
      <v-spinner slot="value" size="10" :loading="true"></v-spinner>
    </v-list-cell>
    <v-list-cell icon="Icon=file-text.svg" v-if="!imageUrl && isReady" />
    <v-list-cell :thumbnail="imageUrl" v-if="isConverted" />
    <v-list-cell :title="file.title" size="3" truncate :subtitle="$t('stati.files.text.' + currentStatus)" />
    <v-list-cell :value="file.file_extension" tabletHidden />
    <v-list-cell :value="$h.formatFileSize(file.file_size)" />
    <v-list-cell :value="$h.formatFileListGroupName(file.lists)" truncate />
    <v-list-cell :value="$h.formatDate(file.created_at, timezone)" />
    <v-list-cell
      iconDropdown
      grey
      icon="Icon=more-horizontal.svg"
      iconColor="#5057af"
      :dropdownData="currentMoreDropdown"
      :dropdownUid="$h.createUniqueUid()"
      :dropdownValue="{ file, document: currentDocument }"
    />
  </v-list-item>
</template>

<script>
export default {
  name: "SignedDocumentListItem",
  props: {
    file: {
      type: Object,
      default: function () {
        return {};
      },
    },
    team: {
      type: String,
      default: "",
    },
    timezone: {
      type: String,
      default: "",
    },
    statiBits: {
      type: Object,
      default: function () {
        return {};
      },
    },
    moreDropdown: {
      type: Array,
      default: () => {
        return [];
      },
    },
    moreDropdownWithDisabled: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getSelf: {
      type: Function,
      default: () => {},
    },
    getPreview: {
      type: Function,
      default: () => {},
    },
    currentProject: {
      type: String,
      required: true,
    },
    currentDocument: {
      type: String,
      required: true,
    },
    documentIsEditable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      item: {},
      amountTry: 10,
      timeWaitStart: 1500,
      timer: null,
      imageUrl: "",
    };
  },
  created() {
    this.item = this.file;
    this.untilReady();
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    isConvertedCalculate(item) {
      return this.statiBits ? this.$h.globalIsBitSet(item.status, this.statiBits.CONVERTED.bit) : false;
    },
    isReadyCalculate(item) {
      if (this.statiBits && item.status) {
        return (
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "VIRUS_SCANNING" &&
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "CONVERTING"
        );
      } else {
        return false;
      }
    },
    isDownloadableCalculate(item) {
      return this.statiBits && item
        ? this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_OK.bit) ||
            this.$h.globalIsBitSet(item.status, this.statiBits.VIRUS_SCAN_RESULT_NA.bit)
        : false;
    },
    getItemPreview() {
      const data = {
        team: this.team,
        project: this.currentProject,
        document: this.currentDocument,
        file: this.item.uid,
        customLoading: true,
      };
      if (this.isConverted && this.item.preview.image) {
        this.getPreview(data).then((res) => {
          this.imageUrl = res;
        });
      } else {
        this.imageUrl = "";
      }
    },
    downloadFile() {
      if (this.isDownloadable) {
        this.$emit("downloadFile");
      }
    },
    untilReady() {
      this.getItemPreview();
      const data = {
        document: this.currentDocument,
        file: this.file.uid,
        project: this.currentProject,
        customLoading: true,
      };
      if (!this.isReady) {
        const vm = this;
        vm.timer = setTimeout(function () {
          vm.getSelf(data)
            .then((response) => {
              vm.item = response;
              vm.amountTry = vm.amountTry - 1;
              if (vm.amountTry <= 0) {
                vm.amountTry = 10;
                vm.timeWaitStart = vm.timeWaitStart + 60000;
              }
              vm.untilReady();
            })
            .catch();
        }, vm.timeWaitStart);
      }
    },
  },
  computed: {
    isConverted() {
      return this.isConvertedCalculate(this.item);
    },
    isReady() {
      return this.isReadyCalculate(this.item);
    },
    isDisabled() {
      return !this.isDownloadable;
    },
    isDownloadable() {
      return this.isDownloadableCalculate(this.item);
    },
    currentStatus() {
      return this.statiBits && this.item ? this.$h.globalGetCurrentFileStatus(this.item.status, this.statiBits) : "";
    },
    currentMoreDropdown() {
      if (this.isDownloadable && this.documentIsEditable) {
        return this.moreDropdown;
      } else {
        return this.moreDropdownWithDisabled;
      }
    },
  },
};
</script>
